export enum InspectionType {
  REGISTRATION = "REGISTRATION",
  TACHOGRAPH = "TACHOGRAPH",
  DIGITAL_TACHOGRAPH = "DIGITAL_TACHOGRAPH",
  FIRE_EXTINGUISHER = "FIRE_EXTINGUISHER",
  FIRST_AID_KIT = "FIRST_AID_KIT",
  TECHNICAL_INSPECTION = "TECHNICAL_INSPECTION",
  FULL_COVERAGE_INSURANCE = "FULL_COVERAGE_INSURANCE",
}
